import React, { useEffect, createElement } from 'react';
import { FadeIn } from './components/FadeIn';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiaryEntry } from './components/DiaryEntry';
import { ProductExplanation } from './components/ProductExplanation';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { TrustBar } from './components/TrustBar';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { PullQuote } from './components/PullQuote';
import { ProductReveal } from './components/ProductReveal';
import { CtaButton } from './components/CtaButton';
import { FaqSection } from './components/FaqSection';
export function App() {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen flex flex-col font-serif selection:bg-forest/20 selection:text-forest" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow w-full max-w-2xl mx-auto pb-12" data-id="element-2">
        <FadeIn data-id="element-3">
          <HeroSection data-id="element-4" />
        </FadeIn>

        <div className="px-4" data-id="element-5">
          <FadeIn delay={0.1} data-id="element-6">
            <DiaryEntry date="Vor 5 Monaten" title="Das Problem" data-id="element-7">
              <p data-id="element-8">
                Es fing schleichend an. Tony hatte mal einen Tag keinen
                Stuhlgang — ich dachte mir nichts dabei. Aber dann wurden es
                zwei Tage, drei Tage, manchmal fast eine ganze Woche. Sein Bauch
                war hart und aufgebläht, man konnte es richtig sehen.
              </p>
              <p data-id="element-9">
                Er lag nur noch rum, wollte nicht mehr spielen, fraß lustlos und
                drehte sich nachts ständig im Körbchen. Wenn er dann doch mal
                musste, war es eine Qual für ihn.{' '}
                <strong data-id="element-10">Es hat mir das Herz gebrochen, ihn so zu sehen.</strong>
              </p>
              <p data-id="element-11">
                Ich habe teureres Futter gekauft, verschiedene Sorten
                ausprobiert, ihm Kürbis untergemischt — nichts hat wirklich
                geholfen. Der Tierarzt hat Blut abgenommen, abgetastet,
                Ultraschall gemacht. Sein Ergebnis: "Seine Darmflora ist
                komplett aus dem Gleichgewicht. Die Verdauung arbeitet viel zu
                langsam."
              </p>
              <p data-id="element-12">
                <strong data-id="element-13">Ich wusste einfach nicht mehr weiter.</strong> Mein
                kleiner Tony, der sonst so fröhlich durch den Garten gerannt
                ist, war nur noch ein Schatten seiner selbst.
              </p>
            </DiaryEntry>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-14">
            <DiaryEntry date="Vor 4 Monaten" title="Der Wendepunkt" data-id="element-15">
              <p data-id="element-16">
                Ich lese über Verdauungsenzyme, über Ballaststoffe, über
                Darmgesundheit. Ich verstehe: das Problem liegt nicht im Futter
                sondern im Darm.
              </p>
              <p data-id="element-17">
                <strong data-id="element-18">
                  Ich hatte schon so viele Sachen ausprobiert — aber dann sah
                  ich, dass fast 900 andere Hundehalter das Topping bewertet
                  hatten, viele mit genau denselben Problemen wie Tony.
                </strong>{' '}
                Ich suche nach natürlicher Unterstützung.
              </p>
            </DiaryEntry>
          </FadeIn>
        </div>

        <FadeIn delay={0.1} data-id="element-19">
          <PullQuote data-id="element-20" />
        </FadeIn>

        <div className="px-4" data-id="element-21">
          <FadeIn delay={0.1} data-id="element-22">
            <DiaryEntry date="Vor 10 Wochen" title="Die Veränderung" data-id="element-23">
              <p data-id="element-24">
                Ein Futtertopping mit Ballaststoffen, Präbiotika und
                verdauungsfördernden Pflanzen. Ich schleiche es langsam ein.
                Tony frisst es problemlos.
              </p>
              <p data-id="element-25">
                <strong data-id="element-26">
                  Nach 10 Tagen hatte Tony zum ersten Mal wieder normalen Stuhl.
                </strong>{' '}
                Sein Bauch hat sich komplett beruhigt.
              </p>
            </DiaryEntry>
          </FadeIn>
        </div>

        <FadeIn delay={0.1} data-id="element-27">
          <div className="px-4 mb-12 flex justify-center" data-id="element-28">
            <CtaButton label="Das Topping das Tony geholfen hat → hier testen" position="story_cta" className="w-full md:w-auto" data-id="element-29" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-30">
          <ProductReveal data-id="element-31" />
        </FadeIn>

        <div className="px-4" data-id="element-32">
          <FadeIn delay={0.1} data-id="element-33">
            <DiaryEntry date="Heute" title="Endlich angekommen" data-id="element-34">
              <p data-id="element-35">
                Tony ist wieder vollkommen gesund. Seine Verdauung ist
                regelmäßig und der Blähbauch ist komplett verschwunden. Er tobt
                wieder wie ein junger Hund.
              </p>
              <p data-id="element-36">
                Dabei habe ich das Futter nicht gewechselt – nur das Topping
                dazugegeben.
              </p>
            </DiaryEntry>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} data-id="element-37">
          <ProductExplanation data-id="element-38" />
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-39">
          <div className="px-4 mb-12 flex justify-center" data-id="element-40">
            <CtaButton label="Jetzt für meinen Hund bestellen" position="ingredients_cta" className="w-full md:w-auto" data-id="element-41" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-42">
          <ExpertQuote data-id="element-43" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-44">
          <Testimonials data-id="element-45" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-46">
          <FaqSection data-id="element-47" />
        </FadeIn>
      </main>

      <FadeIn delay={0.1} data-id="element-48">
        <TrustBar data-id="element-49" />
      </FadeIn>

      <div className="w-full max-w-2xl mx-auto" data-id="element-50">
        <FadeIn delay={0.2} data-id="element-51">
          <CtaSection data-id="element-52" />
        </FadeIn>
      </div>

      <Footer data-id="element-53" />
    </div>;
}